import type { LogMessages } from "../../types/LogMessages";

function LogsItem({log}:{log:LogMessages}) {


    return (


            <div className="row">
                
                <h2>{log.level}</h2>
                <p>{log.message}</p>
                <p>{log.date_creation}</p>
               

            </div>
        
    );
}
export default LogsItem;